import script from "./SubscriptionPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscriptionPopup.vue?vue&type=script&setup=true&lang=ts"

import "./SubscriptionPopup.vue?vue&type=style&index=0&id=c84729de&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c84729de"]])

export default __exports__